import { tagManageList, tagManageDetail, tenantDetail } from '@/api.js'
import Vue from 'vue'
const _codeImgTypes = ['qrcode', 'code128', 'datamatrix', 'logo']
const _textTypes = ['date', 'time', 'datetime', 'text']
const _specialTypes = ['list']
const _fixedTypes = ['date', 'time', 'datetime', 'text', 'select', 'number', 'label','serial_number']
export default {
  methods: {
    rememberLabelFormat(pos, value) {
      this.$utils.setLocalLabel(pos, value)
    },
    _generatePrintHtml(template, data = {}) {
      const { tag, batch } = template
      const { ins_code, batch_list } = data
      const batchHtml = this._generateBatchHtml(batch, batch_list || [])
      const tagHtml = this._generateTagHtml(tag, ins_code || [])
      
      return `${batch.content && batch.content.length ? batchHtml : ''} ${tag.content && tag.content.length ? tagHtml : ''}`
    },
    _extractDataValue(item, key) {
      // 提取字段中数据
      if (key.includes('.')) {
        const keyArrs = key.split('.').map(i => `['${i}']`).join('')
        try {
          return eval(`item${keyArrs}`)
        } catch(error) {
          console.log(`接口数据读取出错，未能获取字段：${key}, ${item}${keyArrs}`)
          console.error(error)
        }
      } else {
        return item[key]
      }
    },
    _generateTagHtml(template, data = [{}]) {
      // 按照数据生成标签打印html
      const { content, w, h } = template

      let string = ''
      data.forEach(d => {
        let pageString = '';
        content.forEach(i => {
          let elementString = '';
          const { type, conditions,printForm } = i
          const printType = printForm || type
          let conditionResult = true
          let conditionExpressionString = ''
          if (conditions && conditions.length && Object.keys(d).length) {
            conditions.forEach((c, ci) => {
              const {
                conditionKey,
                valueKey,
                compareValue
              } = c
              if (ci > 0) {
                conditionExpressionString += c.connectorValue
              }
              const value = valueKey.type === 'label' ? valueKey.text : d[valueKey.key]
              conditionExpressionString += `'${this._extractDataValue(d, conditionKey.key)}'${compareValue}'${value}'`
            })

            conditionResult = eval(conditionExpressionString)
          }

          if (!conditionResult) return false

          if (_fixedTypes.includes(printType)) {
            // 固定文本
            elementString = `<div style="position: absolute; width: ${i.width}px; height: ${i.height}px; left: ${i.x}px; top: ${i.y}px;font-size: ${i.fontSize}px; font-weight: ${i.bold ? 'bold': 'normal'}; line-height: ${i.lineHeight}px;word-break:break-all;background-color: ${i.backColor ? '#000' : 'transparent'}; color: ${i.backColor ? '#fff' : '#000'}; text-align: ${i.textAlign || 'left'};">${i.text}</div>`
          } else if (_codeImgTypes.includes(printType)) {
            // 图片类型
            const itemValue = Object.keys(d).length ? this._extractDataValue(d, i.key) : undefined
            const value = Object.keys(d).length ? Vue.prototype.$utils.generateCode(itemValue, type) : i.img;
            if(value){
              elementString = value ? `<img style="position: absolute; width: ${i.width}px; height: ${i.height}px; left: ${i.x}px; top: ${i.y}px;" src="${value}" />` : ''
            }else{ // 当预览模板的时候img没有值，这时候需要显示text文本
              elementString = `<div style="position: absolute; width: ${i.width}px; height: ${i.height}px; left: ${i.x}px; top: ${i.y}px;font-size: ${i.fontSize}px; font-weight: ${i.bold ? 'bold': 'normal'}; line-height: ${i.lineHeight}px;word-break:break-all;background-color: ${i.backColor ? '#000' : 'transparent'}; color: ${i.backColor ? '#fff' : '#000'}; text-align: ${i.textAlign || 'left'};">${i.text}</div>`
            }
          } else if (_textTypes.includes(printType)) {
            // 文本类型
            let value = ''
            if (Object.keys(d).length) {
              const itemValue = this._extractDataValue(d, i.key)
              const dataValue = itemValue
              const dataValueArray = dataValue ? `${dataValue}`.split(' ') : []
              if (type === 'date') {
                value = dataValueArray[0] || ''
              } else if (type === 'time') {
                value = dataValueArray[1] || ''
              } else if (type === 'datetime') {
                value = dataValue
              } else {
                value = dataValue || ''
              }
            } else {
              value = i.text
            }
            elementString = `<div style="position: absolute; width: ${i.width}px; height: ${i.height}px; left: ${i.x}px; top: ${i.y}px;font-size: ${i.fontSize}px; font-weight: ${i.bold ? 'bold': 'normal'}; line-height: ${i.lineHeight}px;word-break:break-all;background-color: ${i.backColor ? '#000' : 'transparent'}; color: ${i.backColor ? '#fff' : '#000'}; text-align: ${i.textAlign || 'left'};">${value}</div>`
          } else if (_specialTypes.includes(type)) {
            // 特殊类型，目前只有list
            let value = ''
            if (type === 'list') {
              if (Object.keys(d).length) {
                value = d[i.key] || []
              } else {
                value = i.list || []
              }
              
              let listHtml = ''
              value.forEach(i => {
                listHtml += `<div style="display:flex;justify-content: space-between;"><span>${i.name || ''}:</span><span>${i.number || 0}</span></div>`
              })

              elementString = `<div style="position: absolute; width: ${i.width}px; height: ${i.height}px; left: ${i.x}px; top: ${i.y}px;font-size: ${i.fontSize}px; font-weight: ${i.bold ? 'bold': 'normal'}; line-height: ${i.lineHeight}px;word-break:break-all;overflow: hidden;background-color: ${i.backColor ? '#000' : 'transparent'}; color: ${i.backColor ? '#fff' : '#000'}">${listHtml}</div>`
            }
          }

          pageString += elementString
        })

        string += `<div id="printTagArea" class="printTagArea" style="display:none;"><div style="padding:0;margin:0;margin-left:-30px;width:${w}px;height:${h}px;overflow:hidden;position:relative;">${pageString}</div></div>`
      })

      return string
    },
    _generateBatchHtml(template, data = [{}]) {
      // 按照数据生成总码打印html
      const { content, w, h } = template

      let string = ''
      data.forEach(d => {
        let pageString = '';
        content.forEach(i => {
          let elementString = '';
          const { type } = i
          if (type === 'label') {
            // 固定文本
            elementString = `<div style="position: absolute; width: ${i.width}px; height: ${i.height}px; left: ${i.x}px; top: ${i.y}px;font-size: ${i.fontSize}px; font-weight: ${i.bold ? 'bold': 'normal'}; line-height: ${i.lineHeight}px;word-break:break-all;background-color: ${i.backColor ? '#000' : 'transparent'}; color: ${i.backColor ? '#fff' : '#000'}; text-align: ${i.textAlign || 'left'};">${i.text}</div>`
          } else if (_codeImgTypes.includes(type)) {
            // 图片类型
            const value = Object.keys(d).length ? Vue.prototype.$utils.generateCode(d[i.key], type) : i.img;
            elementString = value ? `<img style="position: absolute; width: ${i.width}px; height: ${i.height}px; left: ${i.x}px; top: ${i.y}px;" src="${value}" />` : ''
          } else if (_textTypes.includes(type)) {
            // 文本类型
            let value = ''
            if (Object.keys(d).length) {
              const dataValue = d[i.key]
              const dataValueArray = dataValue ? `${dataValue}`.split(' ') : []
              if (type === 'date') {
                value = dataValueArray[0] || ''
              } else if (type === 'time') {
                value = dataValueArray[1] || ''
              } else if (type === 'datetime') {
                value = dataValue
              } else {
                value = dataValue || ''
              }

              if (i.key === '_total') {
                let total = 0
                const list = d['list'] || []
                list.forEach(i => total += i.number)

                value = total
              }
            } else {
              value = i.text
            }
            elementString = `<div style="position: absolute; width: ${i.width}px; height: ${i.height}px; left: ${i.x}px; top: ${i.y}px;font-size: ${i.fontSize}px; font-weight: ${i.bold ? 'bold': 'normal'}; line-height: ${i.lineHeight}px;word-break:break-all;background-color: ${i.backColor ? '#000' : 'transparent'}; color: ${i.backColor ? '#fff' : '#000'}; text-align: ${i.textAlign || 'left'};">${value}</div>`
          } else if (_specialTypes.includes(type)) {
            // 特殊类型，目前只有list
            let value = ''
            if (type === 'list') {
              if (Object.keys(d).length) {
                value = d[i.key] || []
              } else {
                value = i.list || []
              }
              
              let listHtml = ''
              value.forEach(i => {
                listHtml += `<div style="display:flex;justify-content: space-between;"><span>${i.name || ''}</span><span>*</span><span>${i.number || 0}</span></div>`
              })

              elementString = `<div style="position: absolute; width: ${i.width}px; height: ${i.height}px; left: ${i.x}px; top: ${i.y}px;font-size: ${i.fontSize}px; font-weight: ${i.bold ? 'bold': 'normal'}; line-height: ${i.lineHeight}px;word-break:break-all;overflow: hidden;background-color: ${i.backColor ? '#000' : 'transparent'}; color: ${i.backColor ? '#fff' : '#000'}">${listHtml}</div>`
            }
          }
  
          pageString += elementString
        })

        string += `<div id="printTagArea" class="printTagArea" style="display:none;"><div style="padding:0;margin:0;margin-left:-30px;width:${w}px;height:${h}px;overflow:hidden;position:relative;">${pageString}</div></div>`
      })

      return string
    },
    _getSmartTagList() {
      // 获取自定义标签列表
      const query = {
        status: 1,
        page: 1,
        per_page: 999
      }

      return this.$request('get', tagManageList, query)
      .then(res => {
        if (res) {
          return res.data || []
        }

        return []
      })
    },
    _getSmartTagDetail(id) {
      // 获取自定义标签详情
      if (Number(id)) {
        return this.$request('get', tagManageDetail, { id })
        .then(res => {
          return res || null
        })
      }
    },
    _parseSmartTagDetailContent(detail) {
      // 解析自定义标签内容
      try {
        const list = JSON.parse(detail)

        return list
      } catch (error) {
        console.log('解析自定义标签内容出错', error)        
      }
    },
    _parseSmartTagConfigByDetail(detail = {}) {
      // 根据自定义标签模版详情解析内容
      const { content, size } = detail
      if (!content) return null

      const parsedContent = this._parseSmartTagDetailContent(content)
      const contentType = Vue.prototype.$utils.checkType(parsedContent)
      let data = {}
      if (contentType === 'array') {
        data = {
          tag: {
            w: size.split('x')[0],
            h: size.split('x')[1],
            content: parsedContent
          },

          batch: {
            w: 500,
            h: 300,
            content: []
          }
        }
      } else if (contentType === 'object') {
        const {
          tag,
          batch
        } = parsedContent

        data = {
          tag: {
            w: tag.size.width,
            h: tag.size.height,
            content: tag.inList
          },
          batch: {
            w: batch.size.width,
            h: batch.size.height,
            content: batch.inList
          }
        }
      }

      return data
    },
    _collapseBatch(batches) {
      // 将批次数据折叠
      const list = []
      let total = 0
      batches.forEach((i) => {
        const item = list.filter(l => l.name === i.name)[0]
        if (item) {
          item.number += 1
        } else {
          i.number = 1
          list.push(i)
        }

        total += 1
      })
    
      return { list, total }
    },
    _setLogoByData(data, tenant_id) {
      return new Promise((resolve) => {
        const hasLogo = data.filter(i => i.type === 'logo').length > 0

        if (hasLogo) {
          this._getTenantDetail(tenant_id)
          .then(res => {
            if (res) {
              const { image } = res
              data.forEach(i => {
                if (i.type === 'logo') {
                  i.img = image
                }
              })
            }
            
            resolve(data)
          })
        } else {
          resolve(data)
        }
      })
    },

    // 判断是否有流水号
    _setSerialNumber(data,serialNum) {
        data.forEach((i) => {
          if (i.type === 'serial_number') {
            i.text = serialNum;
            if(_codeImgTypes.includes(i.printForm)){
              i.img = this.$utils.generateCode(serialNum, i.printForm)
            }
          }
        });
        return data
    },

    // 判断是否有标签识别码
    _labelIdenCode(data){
      data.forEach(itemI=>{
        if(itemI.key == "labelIdenCode"){
          let tabIdenCode = itemI.labelIdenCode.split('/')
          let selectData = []
          tabIdenCode.forEach(itemJ=>{
            const matchedKey = data.filter(item=>item.key == itemJ)[0]
            let value = matchedKey ? matchedKey.text : ''
            selectData.push(value)
          })
          itemI.img = this.$utils.generateCode(encodeURIComponent(selectData.join('/')), 'qrcode')
        }
      })
      return data
    },

    _getTenantDetail(tenant_id) {
      const url = tenantDetail.replace('{id}', tenant_id)
      
      return this.$request('get', url)
    },
  }
}